import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  switchWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  tooltip: {
    borderRadius: '5px',
    fontSize: '12px',
    lineHeight: '16px',
    padding: '12px'
  }
}));
